<mat-icon [ngStyle]="iconStyle()" [svgIcon]="iconName"></mat-icon>
